import styled from "styled-components";
import { TEXT_COLORS } from "../../constants/design/colors";
import { SPACING } from "../../constants/design/spacing";

export const TradeColumn = styled.span<{
  flex?: number;
  $color?: string;
  $singleLine?: boolean;
}>`
  padding: 0 ${SPACING.two}px;
  flex: ${({ flex }) => flex ?? 1};
  min-width: 0;
  /* Time only: a wrapped "MMM D HH:mm" spilled onto the next 24px row, and its
     full value is in the cell's title. Price and size must never be clipped. */
  ${({ $singleLine }) =>
    $singleLine &&
    `
    white-space: nowrap;
    overflow: hidden;
  `}
  color: ${({ $color }) => $color ?? TEXT_COLORS.one};
  justify-content: flex-start !important;
`;
